import { useShallow } from 'zustand/react/shallow';

import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';

export const useCheckWelloApp = () =>
  useDeviceInfoStore(
    useShallow(({ webviewType, isMounted }) => ({
      isChecking: !isMounted,
      isWelloApp: webviewType === WEBVIEW_TYPE.WELLO_APP,
    })),
  );
